import { PropsWithChildren } from 'react';

import { ContextState, DataGridContext } from './useDataGridContext.hook';

export const DataGridContextProvider = <C extends ContextState>({
  children,
  value,
}: PropsWithChildren<{ value: C }>) => {
  return <DataGridContext.Provider value={value}>{children}</DataGridContext.Provider>;
};
